import { transformTile } from '../../movie-player/transformers/transform-tile';
import { TilesMeta } from '../../feature-player/types/tiles';

import { useEpisodeOtt } from './use-episode-ott';

export const useTiles = (contentId: string): TilesMeta[] | undefined => {
    const episode = useEpisodeOtt(contentId);

    return (
        episode?.onlineStreams?.streams?.[0]?.streamMeta?.tilesContainer?.reduce<TilesMeta[]>(
            (acc, tile) => {
                if (tile) {
                    acc.push({
                        highRes: transformTile(tile.highResolutionTiles),
                        lowRes: transformTile(tile.lowResolutionTiles),
                        offset: tile.offset,
                    });
                }
                return acc;
            },
            []
        ) || undefined
    );
};
